import { Navigate } from 'react-router-dom';
import { useBrand } from '@/hooks/useBrand';
import { useIsAdmin } from '@/hooks/useAdmin';
import { Loader2 } from 'lucide-react';

interface BrandAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard that only allows brand admins or platform admins.
 */
export function BrandAdminRoute({ children }: BrandAdminRouteProps) {
  const { isBrandAdmin, isLoading: brandLoading } = useBrand();
  const { data: isAdmin, isLoading: adminLoading } = useIsAdmin();

  if (brandLoading || adminLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (isAdmin === true || isBrandAdmin) {
    return <>{children}</>;
  }

  return <Navigate to="/dashboard" replace />;
}
